import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import ROUTE_STATUS from '../../components/constants/routeStatus';
import PackerRouteRowFilteredDelivery from './packerRouteRowFilteredDelivery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

const PackerRouteRow = ({ route, deliveryDayId, customPackingType }) => {
  const [hideDeliveries, setHideDeliveries] = useState(false);

  const { formatMessage } = useIntl();

  const routeLink = `/admin/packing/deliveryDays/${deliveryDayId}/route/${route.id}${
    customPackingType ? `/${customPackingType}` : ''
  }`;

  const statuses = Object.keys(ROUTE_STATUS).map((key) => {
    return ROUTE_STATUS[key];
  });
  const status = statuses.find((s) => s.name === route.status);

  const filteredDeliveries =
    customPackingType && route.deliveries
      ? route.deliveries.filter((delivery) =>
          delivery?.deliveryOrderBatch?.customTypes.some((ct) => ct.type === customPackingType)
        )
      : null;

  return (
    <div className="packer__route m-b-3">
      <Link to={routeLink}>
        <h3 className="m-b-3">
          {status ? `${status.packerIcon} ` : ''}
          {route.driver
            ? formatMessage(
                { id: 'packer.routes.route.row.title.with.driver' },
                { driver: route.driver.name, routeId: route.id }
              )
            : formatMessage({ id: 'packer.routes.route.row.title.no.driver' }, { routeId: route.id })}
        </h3>
      </Link>
      <div>
        <FormattedMessage
          id={'packer.routes.route.row.delivery.status'}
          values={{ status: status ? `${status.name}` : route.status }}
        />
      </div>
      <div>
        {route.packer ? formatMessage({ id: 'packer.routes.route.packer' }, { packer: route.packer.screenName }) : ''}
      </div>
      <div className="m-b-3">
        <FormattedMessage id={'packer.routes.route.row.delivery.count'} values={{ count: route.deliveries.length }} />
      </div>

      {filteredDeliveries && !hideDeliveries ? (
        <div className="m-b-6">
          {filteredDeliveries.map((delivery) => (
            <PackerRouteRowFilteredDelivery customPackingType={customPackingType} delivery={delivery} />
          ))}
        </div>
      ) : (
        ''
      )}

      {customPackingType ? (
        <div className="m-b-3">
          <button onClick={() => setHideDeliveries(!hideDeliveries)} className="btn btn-default btn-small">
            {hideDeliveries ? <FontAwesomeIcon icon={faCaretDown} /> : <FontAwesomeIcon icon={faCaretUp} />}{' '}
            <FormattedMessage
              id={
                hideDeliveries
                  ? 'packer.routes.route.filtered.deliveries.show'
                  : 'packer.routes.route.filtered.deliveries.hide'
              }
            />
          </button>
        </div>
      ) : (
        <div className="m-b-2">
          <Link to={routeLink} className="btn btn-primary">
            <FormattedMessage id={'packer.routes.route.cta'} />
          </Link>
        </div>
      )}
    </div>
  );
};

PackerRouteRow.propTypes = {
  route: PropTypes.object.isRequired,
  deliveryDayId: PropTypes.string.isRequired,
};

PackerRouteRow.defaultProps = {};

export default PackerRouteRow;
